export default function sendData( url: string, data: any, reload?: boolean, callback?: Function ) {
    const XHR = new XMLHttpRequest();
    let urlEncodedData = "",
        urlEncodedDataPairs = [],
        name;

    for( name in data ) {
      urlEncodedDataPairs.push( encodeURIComponent( name ) + '=' + encodeURIComponent( data[name] ) );
    }
    urlEncodedData = urlEncodedDataPairs.join( '&' ).replace( /%20/g, '+' );
    XHR.onreadystatechange = () => {
        if (XHR.readyState === XMLHttpRequest.DONE && XHR.status === 200) {
            if(callback) {
                callback(XHR.responseText);
            }
            if(reload) {
                document.location.reload();
            }
        }
    }
    XHR.open( 'POST', url );
    XHR.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded' );
    XHR.send( urlEncodedData );
}
export function getData( url: string, data: any, reload?: boolean )  {
    const XHR = new XMLHttpRequest();
    let urlEncodedData = "",
        urlEncodedDataPairs = [],
        name;

    for( name in data ) {
      urlEncodedDataPairs.push( encodeURIComponent( name ) + '=' + encodeURIComponent( data[name] ) );
    }
    urlEncodedData = urlEncodedDataPairs.join( '&' ).replace( /%20/g, '+' );

    XHR.onreadystatechange = () => {
        if (XHR.readyState === XMLHttpRequest.DONE && XHR.status === 200) {
            if(reload) {
                document.location.reload();
            }
        }
    }
    XHR.open( 'GET', url );
    XHR.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded' );
    XHR.send( urlEncodedData );
}